import * as React from 'react';
import { capitalize } from 'lodash';
import { graphql } from 'react-apollo';

import ConfirmWithMessageDialog from 'components/ConfirmWithMessageDialog';
import Link from 'components/Link';
import LinkConstants from 'constants/LinkConstants';
// @ts-ignore
import List from 'components/List';
// @ts-ignore
import ListItem from 'components/ListItem';

// @ts-ignore
import DENY_ROLE_REQUESTS_MUTATION from 'roleRequests/containers/mutations/DenyRoleRequests.gql';
import { DenyRoleRequestsInput } from 'globalTypes';
import { denyRoleRequestsVariables } from 'roleRequests/containers/mutations/__generated__/denyRoleRequests';
import { RoleRequest } from 'roleRequests/components/PendingRolesTable';

type Props = {
  organizationUuid: string;
  roleRequest: RoleRequest;
  userRole: string;
  onDenial: () => void;
  onRequestHide: () => void;
  denyRoleRequests: ({ variables }: { variables: denyRoleRequestsVariables }) => Promise<void>;
};

class DenyRoleRequestDialog extends React.Component<Props> {
  handleDenyClicked = (message: string) => {
    const { denyRoleRequests, organizationUuid, roleRequest } = this.props;

    const input: DenyRoleRequestsInput = {
      organizationUuid,
      denials: [
        {
          uuid: roleRequest.uuid,
          message,
        },
      ],
    };

    return denyRoleRequests({ variables: { input } });
  };

  render() {
    const { onDenial, onRequestHide, roleRequest, userRole } = this.props;
    const userName = [roleRequest.user.firstName, roleRequest.user.lastName].join(' ');

    return (
      <ConfirmWithMessageDialog
        copy={
          <React.Fragment>
            <p>
              When you deny {userName}
              ’s request to be a {userRole},
            </p>
            <List size="small">
              <ListItem>
                They will be in this school as “No role.” Go to the people list or click on their
                row to{' '}
                <Link href={LinkConstants.MANAGE_PROFILE}>update their role or remove them</Link>.
              </ListItem>
              <ListItem>Their classes won’t be affected.</ListItem>
              <ListItem>
                They will be notified by email, and you can include an optional message below.
              </ListItem>
            </List>
          </React.Fragment>
        }
        confirmAction={this.handleDenyClicked}
        confirmButtonLabel="Deny request"
        confirmErrorMessage={`Unable to deny the ${userName}'s request to be a ${userRole}. Please try again later.`}
        confirmSuccessMessage={`${capitalize(userRole)} request from ${userName} was denied`}
        eventScreenName="DenyRoleRequestDialog"
        onConfirmSuccess={onDenial}
        onRequestHide={onRequestHide}
        title={`Deny ${userName}'s request to be a ${userRole}?`}
      />
    );
  }
}

const withDenyRoleRequestsMutation = graphql<any, any, any>(DENY_ROLE_REQUESTS_MUTATION, {
  name: 'denyRoleRequests',
});

export { DenyRoleRequestDialog };
export default withDenyRoleRequestsMutation(DenyRoleRequestDialog);
